var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowcaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66658 12V13.3333H6.33325V12H0.999919C0.631732 12 0.333252 11.7015 0.333252 11.3333V0.666667C0.333252 0.29848 0.631732 0 0.999919 0H4.99992C5.79638 0 6.51132 0.349167 6.99992 0.902787C7.48852 0.349167 8.20345 0 8.99992 0H12.9999C13.3681 0 13.6666 0.29848 13.6666 0.666667V11.3333C13.6666 11.7015 13.3681 12 12.9999 12H7.66658ZM12.3333 10.6667V1.33333H8.99992C8.26352 1.33333 7.66658 1.93029 7.66658 2.66667V10.6667H12.3333ZM6.33325 10.6667V2.66667C6.33325 1.93029 5.73632 1.33333 4.99992 1.33333H1.66659V10.6667H6.33325Z",
    fill: "#111822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseIcon);
export default __webpack_public_path__ + "static/media/showcaseIcon.c812c5c6.svg";
export { ForwardRef as ReactComponent };